import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import BottomDrawer from '../../Drawer/Drawer';
import Button from '../../Button/Button';
import { ReactComponent as GreenCheck } from '../../../assets/images/svg/green_check.svg';
import { ReactComponent as AmberAlertTriangle } from '../../../assets/images/svg/amber-alert-triangle.svg';
import { pxToRem } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';
import { variables } from '../../../assets/styles/variables';

const HeaderWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${pxToRem(8)};
  padding-top: ${pxToRem(8)};
`;

const SuccessIcon = styled.div`
  margin-top: ${pxToRem(8)};

  > svg {
    width: ${pxToRem(56)};
    height: ${pxToRem(56)};
  }
`;

const Title = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(16)};
  font-weight: 600;
  line-height: 100%;
  color: ${themeColors.colorTextPrimary};
`;

const Subtitle = styled.div`
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(14)};
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  color: ${themeColors.colorTextSecondary};
`;

const NoticeBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${pxToRem(10)};
  background: ${themeColors.colorBackgroundSecondary};
  border-radius: ${pxToRem(4)};
  padding: ${pxToRem(12)} ${pxToRem(16)};
  margin-top: ${pxToRem(16)};
  font-family: ${variables.family.goldSilver}, sans-serif;
  font-size: ${pxToRem(14)};
  font-weight: 500;
  line-height: 140%;
  color: ${themeColors.colorTextSecondary};

  > svg {
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};
    flex-shrink: 0;
    margin-top: ${pxToRem(2)};
  }
`;

const OK_COLOR = '#1C4792';

const FooterWrap = styled.div`
  > button {
    width: 100%;
    color: ${OK_COLOR};
    border-color: ${OK_COLOR};
  }
`;

const SellFromHomeOrderCancelledDrawer = ({ isOpen, onClose, subtitle }) => {
  const { t } = useTranslation();

  const footer = (
    <FooterWrap>
      <Button
        variant="primaryOutlined"
        textTransform="none"
        onClick={onClose}
        data-cy="button-sfh-order-cancelled-ok"
      >
        {t('sellWizard.sfhWizard.orderCancelled.ok')}
      </Button>
    </FooterWrap>
  );

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      footer={footer}
      maxHeight="70%"
    >
      <HeaderWrap>
        <SuccessIcon>
          <GreenCheck />
        </SuccessIcon>
        <Title>{t('sellWizard.sfhWizard.orderCancelled.title')}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </HeaderWrap>

      <NoticeBox>
        <AmberAlertTriangle />
        <span>
          {t('sellWizard.sfhWizard.transactionHistory.marketLossNotice')}
        </span>
      </NoticeBox>
    </BottomDrawer>
  );
};

SellFromHomeOrderCancelledDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  subtitle: PropTypes.string,
};

export default SellFromHomeOrderCancelledDrawer;
